<a class="export-overview" class="dload" target="_blank">
  <div class="{{ docTypeClass }}"></div>
  <h3>{{ name }}</h3>
  @if (changeDate) {
    <p>Änderungsdatum: {{ numberToDateString(changeDate) }}</p>
  }
</a>
